// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusLabel_root__pJITT"};